module.exports = __webpack_public_path__ + "img/gabinetes_armarios_y_accesorios_1.1f16d06e.jpg";